export const type = "SetName"

export function set(value) {
  return {
    type,
    value,
  }
}

export default set
